var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.options.customId)?_c('section',[_c('hr'),_c('vue-poll',_vm._b({on:{"addvote":_vm.addVote}},'vue-poll',_vm.options,false))],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }